module.exports = __webpack_public_path__ + "img/ttshop_dpj.860de04d.svg";